import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TableComponent } from '../components/table/table.component';
import { AddOrderNoteComponent } from '../../modules/customer-orders/components/forms/add-order-note/add-order-note.component';
import { ReasonConfirmDialogComponent } from '../../modules/customer-orders/components/forms/reason-confirm-dialog/reason-confirm-dialog.component';
import { TabContainerComponent } from '../components/tab-container/tab-container.component';
import { ImgModalComponent } from '../components/prd-img/img-modal.component';
import { ProgressSpinnerComponent } from '../components/progress-spinner/progress-spinner.component';
import { MarkdownPipe } from '../pipes/markdown.pipe';
import { StatusTagPipe } from '../pipes/status-tag.pipe';
import { NoteMarkdownEditorComponent } from '../components/note-markdown-editor/note-markdown-editor.component';

import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DividerModule } from 'primeng/divider';
import { DialogModule } from 'primeng/dialog';
import { FieldsetModule } from 'primeng/fieldset';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TabViewModule } from 'primeng/tabview';
import { SplitterModule } from 'primeng/splitter';
import { StepperModule } from 'primeng/stepper';
import { ChipModule } from 'primeng/chip';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { ToastModule } from 'primeng/toast';
import { TimelineModule } from 'primeng/timeline';
import { TreeModule } from 'primeng/tree';
import { InfoCardComponent } from '../components/info-card/info-card.component';
import { VariableGridCardComponent } from '../components/variable-grid-card/variable-grid-card.component';
import { ProfileSectionComponent } from '../components/profile-section/profile-section.component';
import { DynamicPipe } from '../pipes/dynamic-pipe.pipe';
import { CapitalizeUnderscorePipe } from '../pipes/capitalize-underscore.pipe';
import { SkeletonLoaderComponent } from '../components/skeleton-loader/skeleton-loader.component';
import { SkeletonModule } from 'primeng/skeleton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { PhoneMaskDirective } from '../directives/phone-mask.directive';
import { HeightMaskDirective } from '../directives/height-mask.directive';
import { PhonePipe } from '../pipes/phone.pipe';
import { CardModule } from 'primeng/card';
import { ComingSoonComponent } from '../components/coming-soon/coming-soon/coming-soon.component';
import { PageHeaderComponent } from '../components/page-header/page-header.component';
import { FileUploadModule } from 'primeng/fileupload';
import { TooltipModule } from 'primeng/tooltip';
import { SessionTimeoutModalComponent } from '../components/session-timeout-modal/session-timeout-modal.component';
import { DocumentPreviewComponent } from '../components/document-preview/document-preview.component';
import { DocumentUploadModalComponent } from '../components/document-upload-modal/document-upload-modal.component';
import { AddressValidationDialogComponent } from '../../modules/patients/components/forms/address-validation-dialog/address-validation-dialog.component';
import { PastDateConfirmComponent } from '../components/past-date-confirm/past-date-confirm.component';
import { OrderReminderNotesComponent } from '../components/order-reminder-notes/order-reminder-notes.component';
import { BranchZipLookupComponent } from '../components/branch-zip-lookup/branch-zip-lookup.component';
import { OrderLinePhotoThumbComponent } from '../components/order-line-photo-thumb/order-line-photo-thumb.component';
import { OrderItemExceptionCommentComponent } from '../components/order-item-exception-comment/order-item-exception-comment.component';
import { OrderLinePhotoDialogComponent } from '../components/order-line-photo-dialog/order-line-photo-dialog.component';
import { BulkAccessComponent } from '../components/bulk-access/bulk-access.component';
import { BulkAccessAddDialogComponent } from '../components/bulk-access/bulk-access-add-dialog/bulk-access-add-dialog.component';
import { BulkAccessConfirmDialogComponent } from '../components/bulk-access/bulk-access-confirm-dialog/bulk-access-confirm-dialog.component';

@NgModule({
	declarations: [
		TableComponent,
		TabContainerComponent,
		ProgressSpinnerComponent,
		ImgModalComponent,
		InfoCardComponent,
		VariableGridCardComponent,
		ProfileSectionComponent,
		PageHeaderComponent,
		SkeletonLoaderComponent,
		PhoneMaskDirective,
		HeightMaskDirective,
		PhonePipe,
		ComingSoonComponent,
		DynamicPipe,
		CapitalizeUnderscorePipe,
		SessionTimeoutModalComponent,
		DocumentPreviewComponent,
		DocumentUploadModalComponent,
		AddOrderNoteComponent,
		ReasonConfirmDialogComponent,
		AddressValidationDialogComponent,
		PastDateConfirmComponent,
		OrderReminderNotesComponent,
		BranchZipLookupComponent,
		OrderLinePhotoThumbComponent,
		OrderItemExceptionCommentComponent,
		OrderLinePhotoDialogComponent,
		BulkAccessComponent,
		BulkAccessAddDialogComponent,
		BulkAccessConfirmDialogComponent
	],
	imports: [
		MarkdownPipe,
		StatusTagPipe,
		NoteMarkdownEditorComponent,
		AccordionModule,
		AutoCompleteModule,
		BreadcrumbModule,
		BadgeModule,
		CommonModule,
		CheckboxModule,
		ConfirmDialogModule,
		CalendarModule,
		DropdownModule,
		DividerModule,
		DialogModule,
		DynamicDialogModule,
		TableModule,
		TagModule,
		RouterModule,
		HttpClientModule,
		IconFieldModule,
		InputIconModule,
		InputTextModule,
		InputGroupModule,
		InputGroupAddonModule,
		InputTextareaModule,
		InputNumberModule,
		ButtonModule,
		ToggleButtonModule,
		FormsModule,
		ReactiveFormsModule,
		OverlayPanelModule,
		InputSwitchModule,
		ListboxModule,
		TabViewModule,
		ChipModule,
		MenuModule,
		MessagesModule,
		MessageModule,
		MultiSelectModule,
		RadioButtonModule,
		ProgressSpinnerModule,
		PaginatorModule,
		ProgressBarModule,
		FieldsetModule,
		SplitterModule,
		StepperModule,
		SelectButtonModule,
		SidebarModule,
		ToastModule,
		SkeletonModule,
		SplitButtonModule,
		CardModule,
		TimelineModule,
		FileUploadModule,
		TooltipModule,
		TreeModule
	],
	exports: [
		MarkdownPipe,
		StatusTagPipe,
		NoteMarkdownEditorComponent,
		AutoCompleteModule,
		BreadcrumbModule,
		BadgeModule,
		CommonModule,
		HttpClientModule,
		TableModule,
		TagModule,
		TabContainerComponent,
		RouterModule,
		IconFieldModule,
		CapitalizeUnderscorePipe,
		InputIconModule,
		InputTextModule,
		InputGroupModule,
		InputGroupAddonModule,
		InputTextareaModule,
		InputNumberModule,
		ProfileSectionComponent,
		InfoCardComponent,
		VariableGridCardComponent,
		PageHeaderComponent,
		ButtonModule,
		OverlayPanelModule,
		ToggleButtonModule,
		FormsModule,
		ReactiveFormsModule,
		CheckboxModule,
		ConfirmDialogModule,
		CalendarModule,
		DropdownModule,
		InputSwitchModule,
		ListboxModule,
		TabViewModule,
		ChipModule,
		SplitterModule,
		DynamicDialogModule,
		ProgressSpinnerComponent,
		DividerModule,
		DialogModule,
		MenuModule,
		MessagesModule,
		MessageModule,
		MultiSelectModule,
		RadioButtonModule,
		ProgressSpinnerModule,
		PaginatorModule,
		ProgressBarModule,
		TableComponent,
		ImgModalComponent,
		AccordionModule,
		FieldsetModule,
		StepperModule,
		SelectButtonModule,
		SidebarModule,
		ToastModule,
		SkeletonLoaderComponent,
		PhoneMaskDirective,
		HeightMaskDirective,
		PhonePipe,
		CardModule,
		ComingSoonComponent,
		DynamicPipe,
		CapitalizeUnderscorePipe,
		TimelineModule,
		FileUploadModule,
		TooltipModule,
		TreeModule,
		DocumentPreviewComponent,
		DocumentUploadModalComponent,
		AddOrderNoteComponent,
		ReasonConfirmDialogComponent,
		AddressValidationDialogComponent,
		PastDateConfirmComponent,
		OrderReminderNotesComponent,
		BranchZipLookupComponent,
		OrderLinePhotoThumbComponent,
		OrderItemExceptionCommentComponent,
		OrderLinePhotoDialogComponent,
		BulkAccessComponent
	],
	providers: [CurrencyPipe, DatePipe, DecimalPipe]
})
export class SharedModule {}
